import { gql } from "@apollo/client";

export const GET_APPOINTMENT_RATING_QUESTIONS = gql`
query getAppointmentRatingQuestions {
  fetchQuestions {
    questions{
      _id
      question
      subText
      index
    }
    success
    messages
  }
}
`;
